module.exports = __webpack_public_path__ + "static/media/game-results-icon.5a281deb.svg";